import { StatsDataUserInterface } from '../data/user.interface';
import { StatsStoreInterface } from '../store.interface';

/**
 * User entity stats store
 */
export class StatsStoreUser implements StatsStoreInterface {
  /**
   * Index of added users
   */
  protected entity: { [key: number]: StatsDataUserInterface } = {};

  /**
   * @inheritDoc
   */
  public load(id: number): Promise<StatsDataUserInterface> {
    return new Promise((resolve, reject) => {
      if (this.entity[id]) {
        resolve(this.entity[id]);
      } else {
        reject(new Error('Stats entity user "' + id + '" not found.'));
      }
    });
  }

  /**
   * @inheritDoc
   */
  public add(data: StatsDataUserInterface): void {
    // Check for mandatory ID
    if (!data.id) {
      throw new Error('Unable to add user stats entity because it has no ID!');
    }

    // Keep user (data comes from PHP, so we convert it to the exact structure we expect in TS)
    this.entity[data.id] = {
      id: data.id,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
    };
  }
}
